interface ILessonIframes {
  contentUrl?: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeSrc: string;
  title: string;
}

export const LessonIframes = ({
  contentUrl,
  iframeRef,
  iframeSrc,
  title,
}: ILessonIframes) => (
  contentUrl ? (
    <>
      <iframe
        height="100%"
        width="100%"
        src={contentUrl}
        title={title}
      />
      <iframe
        aria-hidden='true'
        className='hideContent'
        height="1px"
        width="1px"
        ref={iframeRef}
        src={`${iframeSrc}?postMessage=false`}
        tabIndex={-1}
      />
    </>
  ) : (
    <iframe
      height="100%"
      width="100%"
      src={iframeSrc}
      ref={iframeRef}
      title={title}
    />
  )
);
